<template>
	<section class="promotions background-light main-content align-center">
		<div class="row promotions-row flex slide-row">
			<client-only>
				<slot />
			</client-only>
		</div>
	</section>
</template>

<style scoped>
.promotions-row {
	height: 490px;
}

@media (max-width: 1080px) {
	.promotions-row {
		flex-wrap: wrap;
		height: auto;
	}
}
</style>
